const FeatureSwitchComponent = ({ children }) => children;

export default FeatureSwitchComponent;
